module.exports = __webpack_public_path__ + "static/media/under3.ca49fc3f.png";